import { invalidateViewsTags } from 'src/Common/RTK/utils/invalidatetags';
import { UATConstants, HttpVerbs } from '../Common/Models/UATConstants';
import { ServiceFactoryClientExecuteApi } from '../Common/Services/ServiceFactoryToExecuteApi';
import ErrorResponse from '../Models/ErrorResponse';

export class ViewActions {
  public static MarkViewAsDefault(viewId: string, onSuccess: (isSuccess: boolean) => void) {
    const url = `${UATConstants.ApiPaths.MarkViewAsDefault}/${viewId}`;
    ServiceFactoryClientExecuteApi.ExecuteRequest<any>(
      url,
      [],
      HttpVerbs.put,
      undefined,
      (response: any) => {
        invalidateViewsTags();
        onSuccess(true) 
      },
      (response: ErrorResponse) => onSuccess(false),
      false,
      undefined,
      undefined
    );
  }

  public static AddToFavoriteViews(viewId: string, onSuccess: (isSuccess: boolean) => void) {
    const url = `${UATConstants.ApiPaths.AddViewToFavorites}/${viewId}`;
    ServiceFactoryClientExecuteApi.ExecuteRequest<any>(
      url,
      [],
      HttpVerbs.put,
      undefined,
      (response: any) => {
        invalidateViewsTags();
        onSuccess(true) 
      },
      (response: ErrorResponse) => onSuccess(false),
      false,
      undefined,
      undefined
    );
  }

  public static RemoveFromFavoriteViews(viewId: string, onSuccess: (isSuccess: boolean) => void) {
    const url = `${UATConstants.ApiPaths.RemoveViewFromFavorites}/${viewId}`;
    ServiceFactoryClientExecuteApi.ExecuteRequest<any>(
      url,
      [],
      HttpVerbs.put,
      undefined,
      (response: any) => {
        invalidateViewsTags();
        onSuccess(true) 
      },
      (response: ErrorResponse) => onSuccess(false),
      false,
      undefined,
      undefined
    );
  }
  public static SetLanguage(languageCode: string, onSuccess: (isSuccess: boolean) => void) {
    const url = `${UATConstants.ApiPaths.SetUserLanguage}/${languageCode}`;
    ServiceFactoryClientExecuteApi.ExecuteRequest<any>(
      url,
      [],
      HttpVerbs.put,
      undefined,
      (response: any) => onSuccess(true),
      (response: ErrorResponse) => onSuccess(false),
      false,
      undefined,
      undefined
    );
  }
}
